import { AnyAction } from 'redux'

import { Invite } from './invitations-service'
import types from './types'

export { default as actions } from './actions'

type InvitersState = {
  record?: Invite[]
}

const INITIAL_STATE = {}

const reducer = (state: InvitersState = INITIAL_STATE, action: AnyAction) => {
  switch (action.type) {
    case types.FETCH_INVITERS_SUCCESS:
      return {
        record: action.payload,
      }
    default:
      return state
  }
}

export const selectInviters = (store: { inviters: InvitersState }) => store.inviters?.record || []

export default reducer
